import React, { useEffect, useRef, useState } from "react";
import TicketMessageBody from "./TicketMessageBody";

const LINE_CLAMP_CLASSES = {
  1: "line-clamp-1",
  2: "line-clamp-2",
  3: "line-clamp-3",
  4: "line-clamp-4",
  5: "line-clamp-5",
  6: "line-clamp-6",
};

export default function ExpandableTicketMessageBody({ body, collapsedLines = 4 }) {
  const [expanded, setExpanded] = useState(false);
  const [canExpand, setCanExpand] = useState(false);
  const contentRef = useRef(null);
  const clampClass = LINE_CLAMP_CLASSES[collapsedLines] ?? LINE_CLAMP_CLASSES[4];

  useEffect(() => {
    setExpanded(false);
  }, [body]);

  useEffect(() => {
    const element = contentRef.current;
    if (!element || expanded) {
      return undefined;
    }

    const measureOverflow = () => {
      setCanExpand(element.scrollHeight > element.clientHeight + 1);
    };

    measureOverflow();

    const observer = new ResizeObserver(measureOverflow);
    observer.observe(element);

    return () => observer.disconnect();
  }, [body, expanded, clampClass]);

  if (!body || body === "—") {
    return null;
  }

  const showToggle = canExpand || expanded;

  return (
    <div>
      <div ref={contentRef} className={expanded ? undefined : clampClass}>
        <TicketMessageBody body={body} />
      </div>
      {showToggle ? (
        <button
          type="button"
          className="mt-1 text-sm text-[var(--color-accent)] hover:underline"
          onClick={() => setExpanded((value) => !value)}
        >
          {expanded ? "Read less" : "Read more"}
        </button>
      ) : null}
    </div>
  );
}
